import { css } from '@compiled/react';

import { Icon } from '@/libraries/wpl/foundations/src/icon';

import { isContentPlatformFacetAvailable } from '../utils/helpers';
import { LocalizedFilterOptions } from '../utils/localized-filter-options';
import { FilterCategories, FilterOptions, SubFilterObject } from '../utils/types';

type FilterModalBasicProps = {
	subFilter: FilterCategories;
	subFilterObject: SubFilterObject;
	updateFilterObject: (subFilterName: string) => void;
};

export const CustomerStoryFilterModalBasic = ({
	subFilter,
	subFilterObject,
	updateFilterObject,
}: FilterModalBasicProps) => {
	const localizedMap = LocalizedFilterOptions();

	return (
		<div
			css={customerStoryFilterModalBasicStyle}
			className={subFilter}
			id="customer-story-modal-component-parent"
		>
			<div>
				{Object.keys(subFilterObject).map((filterOptionName: string, index: number) => {
					const filterObject = subFilterObject[filterOptionName] as FilterOptions;
					const active: boolean = filterObject.stagedActive;
					const optionId = `option-${subFilter.replace(/\s/g, '')}-${index}`;
					return (
						<label
							key={filterOptionName}
							htmlFor={optionId}
							className="filter-radio-button-container"
						>
							<input
								id={optionId}
								type="checkbox"
								onClick={() => updateFilterObject(filterOptionName)}
								css={actualInputStyle}
							/>
							<span className={active ? 'checked' : ''}>
								<Icon name="featurecheckmark" size="xs" color="#FFFFFF" />
							</span>
							{isContentPlatformFacetAvailable(subFilter)
								? filterOptionName
								: localizedMap[filterOptionName]}
						</label>
					);
				})}
			</div>
		</div>
	);
};

const customerStoryFilterModalBasicStyle = css({
	position: 'absolute',
	backgroundColor: 'white',
	borderRadius: '20px',
	zIndex: 2,
	insetBlockStart: '55px',
	padding: '16px 24px 24px 24px',
	flexDirection: 'column',
	boxShadow: '0px 8px 12px 0px #091E4226, 0px 0px 1px 0px #091E424F',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& > div': {
		display: 'flex',
		flexDirection: 'column',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.filter-radio-button-container': {
		margin: '8px 0 0 0',
		cursor: 'pointer',
		display: 'flex',
		flexWrap: 'nowrap',
		alignItems: 'center',
		justifyContent: 'flex-start',
		':hover': {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
			span: {
				// eslint-disable-next-line local/ensure-wac-token-usage
				border: '2px solid #1868DB',
			},
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		span: {
			width: '20px',
			height: '20px',
			borderRadius: '3px',
			// eslint-disable-next-line local/ensure-wac-token-usage
			border: '2px solid #DDDEE1',
			flexBasis: '20px',
			marginInlineEnd: '8px',
			// eslint-disable-next-line local/ensure-wac-token-usage
			background: '#FFFFFF',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
			svg: {
				opacity: 0,
			},
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'span.checked': {
			// eslint-disable-next-line local/ensure-wac-token-usage
			background: '#1868DB',
			// eslint-disable-next-line local/ensure-wac-token-usage
			border: '2px solid #1868DB',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
			svg: {
				opacity: 1,
			},
		},
	},
});

const actualInputStyle = css({
	position: 'absolute',
	zIndex: -1,
	opacity: 0,
});
